import { getScrollX, getScrollY } from '../ADNDHelpers'

export const DEFAULT_TOP_EDGE = 150
export const DEFAULT_BOTTOM_EDGE = 150
export const DEFAULT_LEFT_EDGE = 120
export const DEFAULT_RIGHT_EDGE = 120

export const SCROLL_ACTIVATION_TIMEOUT = 1000

const props = {
  started: false,
  active: false,
  topEdge: DEFAULT_TOP_EDGE,
  bottomEdge: DEFAULT_BOTTOM_EDGE,
  leftEdge: DEFAULT_LEFT_EDGE,
  rightEdge: DEFAULT_RIGHT_EDGE,
  stepX: 0,
  stepY: 0,
  lastX: null,
  lastY: null
}

const LAYER = {
  updatesState: false,
  start(/*event*/) {
    if (!props.started) {
      props.started = true
      setTimeout(() => {
        if (props.started) {
          props.active = true
        }
      }, SCROLL_ACTIVATION_TIMEOUT)
    }
    return LAYER
  },
  stop(/*event*/) {
    props.started = false
    props.active = false
    return LAYER
  },
  frame(state) {
    if (props.active) {
      const scrollX = getScrollX()
      const scrollY = getScrollY()
      const x = state.cursor.x
      const y = state.cursor.y
      if (x != props.lastX || y != props.lastY) {
        props.stepY = 0
        props.stepX = 0
        if (scrollY > 0 && y <= scrollY + props.topEdge) {
          props.stepY = Math.min(-1, -props.topEdge + y - scrollY) >> 2
        } else if (scrollY < document.body.scrollHeight - window.innerHeight) {
          const bottomEdge = scrollY + window.innerHeight - props.bottomEdge
          if (y >= bottomEdge) {
            props.stepY = Math.max(1, y - bottomEdge) >> 2
          }
        }
        if (scrollX > 0 && x <= scrollX + props.leftEdge) {
          props.stepX = Math.min(-1, -props.leftEdge + x - scrollX) >> 2
        } else if (scrollX < document.body.scrollWidth - window.innerWidth) {
          const rightEdge = scrollX + window.innerWidth - props.rightEdge
          if (x >= rightEdge) {
            props.stepX = Math.max(1, x - rightEdge) >> 2
          }
        }
        props.lastX = x
        props.lastY = y
      }
      if (
        (props.stepY < 0 && scrollY <= 0) ||
        (props.stepY > 0 && scrollY >= document.body.scrollHeight - window.innerHeight)
      ) {
        props.stepY = 0
      }
      if (
        (props.stepX < 0 && scrollX <= 0) ||
        (props.stepX > 0 && scrollX >= document.body.scrollWidth - window.innerWidth)
      ) {
        props.stepX = 0
      }
      if (0 != props.stepX || 0 != props.stepY) {
        window.scrollBy(props.stepX, props.stepY)
      }
    }
    return state
  }
}

export default function ADNDEdgeScrollingLayer({
  topEdge = DEFAULT_TOP_EDGE,
  bottomEdge = DEFAULT_BOTTOM_EDGE,
  leftEdge = DEFAULT_LEFT_EDGE,
  rightEdge = DEFAULT_RIGHT_EDGE
} = {}) {
  props.topEdge = topEdge
  props.bottomEdge = bottomEdge
  props.leftEdge = leftEdge
  props.rightEdge = rightEdge
  return LAYER
}
